import { useRef, useSyncExternalStore } from 'react';
import { FormikProps } from 'formik';
import { useFormState } from './useFormState';

export const useFormField = <FormValuesT, R>(callback: (formikState: FormikProps<FormValuesT>) => R): R => {
  const { observer, getState } = useFormState<FormValuesT>();

  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  return useSyncExternalStore(
    (onStoreChange) => {
      const listener = (_: FormikProps<any>) => onStoreChange();
      observer.subscribe(listener);
      return () => observer.unsubscribe(listener);
    },
    () => callbackRef.current(getState()),
  );
};